<template>
  <a-modal
    :visible="visible"
    :title="title"
    class="use-token-modal"
    :getContainer="false"
    width="60%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <table class="table">
      <thead>
        <th colspan="2">翻译关键词句式</th>
        <th colspan="2">生成相关词句式</th>
        <th colspan="2">翻译文章句式</th>
        <th colspan="2">固定句式</th>
      </thead>
      <tbody>
        <tr>
          <td>输入</td>
          <td>输出</td>
          <td>输入</td>
          <td>输出</td>
          <td>输入</td>
          <td>输出</td>
          <td>输入</td>
          <td>输出</td>
        </tr>
        <tr>
          <td>{{ data.prompt_tokens_total_2 }}</td>
          <td>{{ data.completion_tokens_total_2 }}</td>
          <td>{{ data.prompt_tokens_total_3 }}</td>
          <td>{{ data.prompt_tokens_total_3 }}</td>
          <td>{{ data.prompt_tokens_total_4 }}</td>
          <td>{{ data.completion_tokens_total_4 }}</td>
          <td>{{ data.prompt_tokens_total_1 }}</td>
          <td>{{ data.completion_tokens_total_1 }}</td>
        </tr>
      </tbody>
    </table>
  </a-modal>
</template>

<script>
import API from "./api";

export default {
  name: "useTokenModal",
  props: {
    title: {
      type: String,
      default: "使用token明细"
    }
  },
  data() {
    return {
      data: {},
      visible: false
    };
  },
  mounted() {},
  methods: {
    open(id, type) {
      this.visible = true;
      this.getData(id, type);
    },
    getData(id, type) {
      // type 1 产品分类，3 新闻列表，5 案例列表， 13 产品
      API.service
        .LOG_TOKEN_DETAILS({
          id: id,
          type: type
        })
        .then((res) => {
          this.data = res.data.data;
        });
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.table {
  width: 100%;
}
.table th {
  width: 20%;
  padding: 16px 16px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.3s ease;
  text-align: center;
}
.table tr td {
  padding: 16px 16px;
  overflow-wrap: break-word;
  border-bottom: 1px solid #e8e8e8;
  transition: all 0.3s, border 0s;
  text-align: center;
}
.use-token-modal /deep/.ant-modal-footer > div {
  display: flex !important;
  flex-direction: row-reverse !important;
  justify-content: center;
}
.use-token-modal /deep/.ant-modal-footer > div .ant-btn {
  margin: 0 10px;
}
</style>
